import {injectable, decorate} from 'inversify';
import {WixSdk} from '@wix/js-sdk-wrapper';
import {getOriginalComponentId} from '../env/compId';
import {IWixPubSub} from './IWixPubSub';

export class WixPubSub implements IWixPubSub {
  publish(event: string, data: any) {
    WixSdk.PubSub.publish(event, {...data, targetComponentId: getOriginalComponentId()}, false);
  }
}

decorate(injectable(), WixPubSub);
